import { PersoneelsdienstModel } from "@personeel/models/PersoneelsdienstModel.ts";
import { Fragment } from "react/jsx-runtime";
import gridStyles from "../../WerklijnenContainer/WerklijnenContainer.module.css";
import styles from "./PersoneelsdienstLabel.module.css";

interface ISidebar {
  standplaatsDrglptNaam: string;
  dienstnummer: number;
  diensten: PersoneelsdienstModel[];
}

export const personeelsdienstLabelWidth = 150;

export function PersoneelsdienstLabel({
  standplaatsDrglptNaam,
  dienstnummer,
  diensten,
}: Readonly<ISidebar>) {
  return (
    <div className={gridStyles["grid-item"] + " " + gridStyles["grid-sidebar"]}>
      <tractie-tooltip has-arrow={true} appearance="subtle">
        <div slot="invoker" className={styles["personeeldienst-label"]}>
          {standplaatsDrglptNaam + " " + dienstnummer}
        </div>
        <div slot="content">
          {diensten.map((dienstNummerData: PersoneelsdienstModel) => {
            return (
              <Fragment
                key={
                  dienstNummerData.standplaatsDrglptNaam +
                  dienstNummerData.dienstnummer +
                  dienstNummerData.starttijd.toUnixInteger()
                }
              >
                {dienstNummerData.starttijd
                  .toFormat("ccc HH:mm")
                  .concat(" - ")
                  .concat(dienstNummerData.eindtijd.toFormat("ccc HH:mm"))}
                <br />
              </Fragment>
            );
          })}
        </div>
      </tractie-tooltip>
    </div>
  );
}
